const debugModeCookie = new RegExp(/kbbdebugmode/gi);
export default function () {
  let isDebugModeOn = false;
  if (typeof window !== 'undefined') {
    const hasDebugModeParam = /debugmode/gi.test(window.location.search);
    const turnDebugModeOff = /debugmode=off/gi.test(window.location.search);
    const hasDebugModeCookie = debugModeCookie.test(window.document.cookie);
    isDebugModeOn = (hasDebugModeParam || hasDebugModeCookie) && !turnDebugModeOff;
    const cookieMaxAge = turnDebugModeOff ? -1 : '3600';
    if (hasDebugModeParam) {
      document.cookie = `${debugModeCookie.source}=on;max-age=${cookieMaxAge};`;
    }
  }
  return isDebugModeOn;
}